import React from 'react'
import styles from './FilterHeader.module.css'
import classnames from 'classnames'
import HiddenHeading from 'components/HiddenHeading/HiddenHeading'

type HeadingLevel = 'h1' | 'h2'

export interface FilterHeaderProps {
  title?: string
  query?: string
  headingLevel: HeadingLevel
  description?: string
  hideTitle?: boolean
}

const Heading = ({
  headingLevel,
  hideHeading,
  children,
}: {
  headingLevel: HeadingLevel
  hideHeading: boolean
  children
}) => {
  if (hideHeading) {
    return <HiddenHeading text={children} level={headingLevel} />
  }

  return headingLevel === 'h1' ? (
    <h1 className={classnames(styles.header, styles.headerLevelOne)}>
      {children}
    </h1>
  ) : (
    <h2 className={classnames(styles.header, styles.headerLevelTwo)}>
      {children}
    </h2>
  )
}

export const FilterHeader = ({
  title,
  query,
  headingLevel,
  description,
  hideTitle = false,
}: FilterHeaderProps) => {
  if (title) {
    return (
      <div>
        <Heading headingLevel={headingLevel} hideHeading={hideTitle}>
          {title}
        </Heading>
        {description && <p className={styles.description}>{description}</p>}
      </div>
    )
  }

  if (query && query.length) {
    return (
      <Heading headingLevel={headingLevel} hideHeading={hideTitle}>
        Du sökte efter
        <span className={styles.highlighted}>{` "${query}"`}</span>
      </Heading>
    )
  }

  return (
    <Heading headingLevel={headingLevel} hideHeading={hideTitle}>
      Alla program och serier
    </Heading>
  )
}

export default FilterHeader
